import type { TradeLogicKindV2 } from '@/types/appRouter';
import type { TradeLogicRegistryFeatureListInput, TradeLogicRegistrySurface } from './types';

export interface TradeLogicAuthoringFeatureQueryOptions {
    families?: string[];
    providerIds?: string[];
    featureKeys?: string[];
    surfaces?: TradeLogicRegistrySurface[];
    definitionKind?: TradeLogicKindV2;
    discoverable?: boolean;
}

export const buildTradeLogicAuthoringFeatureListInput = (
    options: TradeLogicAuthoringFeatureQueryOptions = {}
): TradeLogicRegistryFeatureListInput => {
    const hasExplicitDiscoverableFilter = Object.prototype.hasOwnProperty.call(options, 'discoverable');

    return {
        families: options.families,
        providerIds: options.providerIds,
        featureKeys: options.featureKeys,
        surfaces: options.surfaces ?? ['rustBacktest', 'tsBacktest'],
        definitionKind: options.definitionKind,
        discoverable: hasExplicitDiscoverableFilter ? options.discoverable : true
    };
};
